export const contactUsFormDropdown = [
  // { title: 'Support', email: 'info@appko.com' },
  { title: 'Sales', email: 'sales@appko.com' },
  { title: 'Support', email: 'seandulac@gmail.com' },
  { title: 'Jobs', email: 'jobs@appko.com' },
]

export const slidersRotationSpeed = 6000
